module.exports = __webpack_public_path__ + "static/media/login_middle.f72f5d58.png";